import type { LabResultEscalationList } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1401 (Ö-473) — "Saknade provsvar", the operational queue, admin only.
// The API logs every patient it returns as a read on the support basis; PDL
// purpose: administration.

const BASE = `${API_BASE}/employee-api/v1/lab-result-escalations`;

export async function fetchLabResultEscalations(): Promise<LabResultEscalationList> {
  const res = await apiFetch(BASE, {
    headers: { ...commonHeaders(), "X-Access-Purpose": "administration" },
    ...withCredentials,
  });
  return jsonOr401(res);
}
